import { Location } from "./location";
import * as Enumerable from 'linq-es2015';
import { HubManager } from "../services/hub-manager";
import { HttpClient } from "aurelia-fetch-client";
import { Structure } from "./structure";
import { EventAggregator, Subscription } from "aurelia-event-aggregator";
import { IApplicationUser, ApplicationUser } from "./application-user";
import { autoinject } from "aurelia-framework";
import { GreenhouseDataEvents } from "../events/data-events";
import { LocationHierarchy } from "./location-hierarchy";


@autoinject
export class LocationApiProxy {

    locations: Location[];
    selectedLocations: Location[] = new Array<Location>();
    locationSelectedSubscription: Subscription;
    hubManager: HubManager;
    httpClient: HttpClient;
    eventAggregator: EventAggregator;
    locationsLoaded: boolean = false;
    applicationUser: IApplicationUser;

    constructor(httpClient: HttpClient, hubManager: HubManager, eventAggregator: EventAggregator, applicationUser: ApplicationUser) {
        this.hubManager = hubManager;
        this.httpClient = httpClient;
        this.eventAggregator = eventAggregator;
        this.applicationUser = applicationUser;
        //this.loadLocations();
        this.subscribeToLocationSelected();
    }

    loadLocations() {
        if (!this.locations) {
			this.httpClient.fetch('api/Location/Hierarchy')
                .then(result => result.json() as Promise<LocationHierarchy>)
                .then(registry => {
                    this.locationsLoaded = true;
                    this.locations = registry.locations;
					this.selectAllLocations();
                    this.eventAggregator.publish(GreenhouseDataEvents.locationsLoaded);
                });
        }
	}

	selectAllLocations() {
		this.clearSelectedLocations();
		for (let i = 0; i < this.locations.length; i++) {
			this.selectedLocations[i] = this.locations[i];
		}
	}

	clearSelectedLocations() {
		this.selectedLocations = new Array<Location>();
	}

    subscribeToLocationSelected() {
        this.locationSelectedSubscription = this.eventAggregator.subscribe(GreenhouseDataEvents.locationSelected,
            (location) => {
                //this.selectedLocation = location;
            });
    }

  
    //public getGreenhouse(locationCode: string, code: string): Structure {
    //    const location = this.getLocation(locationCode);
    //    const greenhouses = Enumerable.AsEnumerable(location.structures);
    //    return greenhouses.FirstOrDefault(greenhouse => greenhouse.code === code);
    //}

    //public getLocation(locationCode: string): Location {
    //    const locations = Enumerable.AsEnumerable(this.locations);
    //    return locations.FirstOrDefault(location => location.code === locationCode);
    //}
}